import readTimeEstimate from 'read-time-estimate';

const defaultReadTime = '1 min read';

export const estimateReadTime = (htmlString: string) => {
  const readTimeEstimateObject = readTimeEstimate(htmlString);

  const humanizedDuration =
    readTimeEstimateObject?.humanizedDuration || defaultReadTime;

  const numberRegex = /([0-9])+/g;

  const time = humanizedDuration.match(numberRegex)?.[0];

  if (humanizedDuration === 'less than a minute') return '1 min read';
  else return `${time} min read`;
};
